import { EXERCISE_LOG_KEY } from '../../exercise-log/model/constants'

const EXERCISES_ACTIVITY_UI_DOMAIN = 'exercisesActivityUi'

const EXERCISES_ACTIVITY_UI_TAB = {
  WEEK: 1,
  MONTH: 2,
  YEAR: 3
}

const EXERCISES_ACTIVITY_UI_KEY = {
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
  ACTIVE_TAB: 'activeTab',
  CURRENT_DATE: 'currentDate',
  VALUE_KEY: 'valueKey',
  IS_HIDDEN: 'isHidden'
}

const EXERCISES_ACTIVITY_UI_PATH = {
  WEEK: `${EXERCISES_ACTIVITY_UI_DOMAIN}.${EXERCISES_ACTIVITY_UI_KEY.WEEK}`,
  MONTH: `${EXERCISES_ACTIVITY_UI_DOMAIN}.${EXERCISES_ACTIVITY_UI_KEY.MONTH}`,
  YEAR: `${EXERCISES_ACTIVITY_UI_DOMAIN}.${EXERCISES_ACTIVITY_UI_KEY.YEAR}`,
  ACTIVE_TAB: `${EXERCISES_ACTIVITY_UI_DOMAIN}.${EXERCISES_ACTIVITY_UI_KEY.ACTIVE_TAB}`,
  CURRENT_DATE: `${EXERCISES_ACTIVITY_UI_DOMAIN}.${EXERCISES_ACTIVITY_UI_KEY.CURRENT_DATE}`,
  VALUE_KEY: `${EXERCISES_ACTIVITY_UI_DOMAIN}.${EXERCISES_ACTIVITY_UI_KEY.VALUE_KEY}`,
  IS_HIDDEN: `${EXERCISES_ACTIVITY_UI_DOMAIN}.${EXERCISES_ACTIVITY_UI_KEY.IS_HIDDEN}`
}

const EXERCISES_ACTIVITY_UI_TAB_TO_KEY = {
  [EXERCISES_ACTIVITY_UI_TAB.WEEK]: EXERCISES_ACTIVITY_UI_KEY.WEEK,
  [EXERCISES_ACTIVITY_UI_TAB.MONTH]: EXERCISES_ACTIVITY_UI_KEY.MONTH,
  [EXERCISES_ACTIVITY_UI_TAB.YEAR]: EXERCISES_ACTIVITY_UI_KEY.YEAR
}

const EXERCISES_ACTIVITY_UI_TAB_TO_PATH = {
  [EXERCISES_ACTIVITY_UI_TAB.WEEK]: EXERCISES_ACTIVITY_UI_PATH.WEEK,
  [EXERCISES_ACTIVITY_UI_TAB.MONTH]: EXERCISES_ACTIVITY_UI_PATH.MONTH,
  [EXERCISES_ACTIVITY_UI_TAB.YEAR]: EXERCISES_ACTIVITY_UI_PATH.YEAR
}

const EXERCISES_ACTIVITY_UI_DEFAULT_DATE_FORMAT = 'P'

const EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT = {
  [EXERCISES_ACTIVITY_UI_TAB.WEEK]: EXERCISES_ACTIVITY_UI_DEFAULT_DATE_FORMAT,
  [EXERCISES_ACTIVITY_UI_TAB.MONTH]: 'I-yyyy',
  [EXERCISES_ACTIVITY_UI_TAB.YEAR]: 'MM-yyyy'
}

const EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_MESSAGE_FORMAT = {
  [EXERCISES_ACTIVITY_UI_TAB.WEEK]: 'EEEEE',
  [EXERCISES_ACTIVITY_UI_TAB.MONTH]: 'MMM dd',
  [EXERCISES_ACTIVITY_UI_TAB.YEAR]: 'MMM'
}

const EXERCISES_ACTIVITY_UI_STATE = {
  [EXERCISES_ACTIVITY_UI_KEY.WEEK]: {},
  [EXERCISES_ACTIVITY_UI_KEY.MONTH]: {},
  [EXERCISES_ACTIVITY_UI_KEY.YEAR]: {},
  [EXERCISES_ACTIVITY_UI_KEY.ACTIVE_TAB]: EXERCISES_ACTIVITY_UI_TAB.WEEK,
  [EXERCISES_ACTIVITY_UI_KEY.CURRENT_DATE]: null,
  [EXERCISES_ACTIVITY_UI_KEY.VALUE_KEY]: EXERCISE_LOG_KEY.MAX_WEIGHT,
  [EXERCISES_ACTIVITY_UI_KEY.IS_HIDDEN]: null
}

const EXERCISES_ACTIVITY_UI_ACTION = {
  ADD_EXERCISE_LOG: 'EXERCISES_ACTIVITY_UI_ADD_EXERCISE_LOG',
  UPDATE_ACTIVE_TAB: 'EXERCISES_ACTIVITY_UI_UPDATE_ACTIVE_TAB',
  UPDATE_CURRENT_DATE: 'EXERCISES_ACTIVITY_UI_UPDATE_CURRENT_DATE',
  RESET_CURRENT_DATE: 'EXERCISES_ACTIVITY_UI_RESET_CURRENT_DATE',
  SHOW: 'EXERCISES_ACTIVITY_UI_SHOW',
  HIDE: 'EXERCISES_ACTIVITY_UI_HIDE'
}

const EXERCISES_ACTIVITY_UI_ANALYTICS_EVENT = {
  TAB: 'Exercise Activity Tab',
  GET_PREMIUM: 'Exercise Activity Get Premium',
  HEADER: 'Exercise Activity Header'
}

export {
  EXERCISES_ACTIVITY_UI_DOMAIN,
  EXERCISES_ACTIVITY_UI_KEY,
  EXERCISES_ACTIVITY_UI_TAB,
  EXERCISES_ACTIVITY_UI_PATH,
  EXERCISES_ACTIVITY_UI_STATE,
  EXERCISES_ACTIVITY_UI_ACTION,
  EXERCISES_ACTIVITY_UI_TAB_TO_PATH,
  EXERCISES_ACTIVITY_UI_TAB_TO_KEY,
  EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT,
  EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_MESSAGE_FORMAT,
  EXERCISES_ACTIVITY_UI_ANALYTICS_EVENT,
  EXERCISES_ACTIVITY_UI_DEFAULT_DATE_FORMAT
}
